import cs from './cs.json';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import nl from './nl.json';

export const languages = {
  cs: cs,
  de: de,
  en: en,
  fr: fr,
  nl: nl,
};



// WEBPACK FOOTER //
// ./src/translations/index.js